import { render, staticRenderFns } from "./QuestionsPage.vue?vue&type=template&id=beada22e&scoped=true"
import script from "./QuestionsPage.vue?vue&type=script&lang=js"
export * from "./QuestionsPage.vue?vue&type=script&lang=js"
import style0 from "./QuestionsPage.vue?vue&type=style&index=0&id=beada22e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beada22e",
  null
  
)

export default component.exports